/**
 * THIS IS AN AUTOGENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY
 * To add new icons to the system, or to update existing icons, run `clyde mana assets sync -t icons`.
 */

import * as React from 'react';
import tokens from '@discordapp/tokens/web';

import addDefaultIconProps from '../addDefaultIconProps';
import {getIconSize} from '../getIconSize';

import type {SingleColorIconProps} from '../IconTypes';

/**
 * ![PlaybackOnIcon](data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsTAAALEwEAmpwYAAAChklEQVR4nN2Vy4sTQRCHg49V8HVU8XUSFRU9+ToYUBdDku6qCfRUTbK4J+NNwYMiCMGjB3XXFf0fZBdBRBF8oXgSBDGCevaBuApGDyvurlKTmt3ozISYeLKhYaof9VX/uqsmk/nvmnNumUF6YpHqtVptTjQOUN5qgIZl3CJ90143wEMFz9/SkfNqtTrfIt+xyD8N0lMZy+VyCyzwZQM0JeNJ3QBPGqBLzrm+tgCLdKy5gd4Vi26tODfI99TRRHgCyzv7+wcWSZdvi3RR5sI1QHdTIblcZakBGg8BHudkzABdUedvCp6/LS0wgPJ2WdOE8EjiIoM80JSG77doPiXRRc4BaI1FGjXIDekW6Zq1bkMLZCKUy/DmuDzAYxrt4Wb0PKRyDUfODfCn+B3QZ5lTHyN6f+eTTvBSJgulYL3aL8RGDHbo/Ywq8Eah4FZ5XmW1Bb6pslwN93j+LrWfxwHAX2VSLq/Vds4tVmBDbHE8q71IFp7ii9iyVmVupAKstUuSABbokUF+GJNWpUqzWwGvZKJYCjaqJM+aQH9vWs4Y4HMxQEogM5cMEBxRwFnVcywJ0Oo80WEMYP1DmiwPxM6XyusM8HfNi31xaehjMyDak+m0Bs1uCvIa5Rl9OeOItOn3E6dI0fYUHh/Vd/xWSoVzbm4kXVg+MNid6aVls9l5Fvh2a7HLDg4ujMbCTEUOeoKENemPcp0VMNIFhfwoYpBN22+QH4t8XcHNzMuhukBj84aXq5wfugI45/os0GuFHI8HQCf1Jd7KdNsA/IMWeVqesAE+4XmVlXnnVhjkUyJfmKxtJOyoWeTTAkn4u00LqCfnUSsC7TdI18PcAX4fVlbrH/gnzv+m/QL+rIrIpxrtbQAAAABJRU5ErkJggg==)
 */
export const PlaybackOnIcon = ({
  size = 'md',
  width,
  height,
  color = tokens.colors.INTERACTIVE_NORMAL,
  colorClass = '',
  ...props
}: SingleColorIconProps) => {
  const iconSize = getIconSize(size);
  const iconWidth = iconSize?.width ?? width;
  const iconHeight = iconSize?.height ?? height;
  return (
    <svg
      {...addDefaultIconProps(props)}
      xmlns="http://www.w3.org/2000/svg"
      width={iconWidth}
      height={iconHeight}
      fill="none"
      viewBox="0 0 24 24">
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M5.32 2.27a1 1 0 1 1 1.36 1.46A8.55 8.55 0 0 0 4 10c0 2.5 1.04 4.74 2.68 6.27a1 1 0 1 1-1.36 1.46A10.55 10.55 0 0 1 2 10c0-3.06 1.28-5.82 3.32-7.73Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M8 10a6 6 0 0 1 12 0v1a1 1 0 1 0 2 0v-1a8 8 0 1 0-16 0c0 3.85 3.04 6.56 4.85 7.84.69.49 1.15 1.34 1.68 2.4A5 5 0 0 0 22 18a1 1 0 1 0-2 0 3 3 0 0 1-5.68 1.34l-.02-.03c-.49-.97-1.14-2.28-2.3-3.1-1.74-1.24-4-3.42-4-6.21Z"
        className={colorClass}
      />
      <path
        fill={typeof color === 'string' ? color : color.css}
        d="M16 11.17V10a2 2 0 1 0-4 0 1 1 0 1 1-2 0 4 4 0 0 1 8 0v2a1 1 0 0 1-1 1 1 1 0 0 0-1 1 1 1 0 1 1-2 0 3 3 0 0 1 2-2.83Z"
        className={colorClass}
      />
    </svg>
  );
};
